import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ModalService } from '@parashift/shared/components';

@Component({
    selector: 'app-repeat-section',
    templateUrl: './repeat-section.component.html',
    imports: [NgClass, FaIconComponent, TooltipModule, FormlyModule]
})
export class RepeatSectionComponent extends FieldArrayType {
  private cdRef = inject(ChangeDetectorRef);
  private modalService = inject(ModalService);
  private destroyRef = inject<DestroyRef>(DestroyRef);

  renderingStartIndex = 0;
  hiddenFieldsCount = 0;
  hiddenFieldsCountTranslation = '';

  constructor() {
    super();
  }

  removeSection(i) {
    if (this.props.onRemoveSection) {
      this.props.onRemoveSection(this.model[i], i);
    }
    this.remove(i);
  }

  confirmRemovingAllSections() {
    this.modalService.confirmation({
      initialState: {
        title: $localize `:@@shared.components.forms.repeat_section.delete_items:Delete items`,
        description: $localize `:@@shared.components.forms.repeat_section.delete_items_confirm:Do you want to delete all items?`
      }
    })
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => {
      this.removeAllSections();
    });
  }

  private removeAllSections() {
    for (let i = this.model.length - 1; i >= 0; i--) {
      super.remove(i);
    }
  }

  moveUp(position) {
    let new_position = position - 1;

    if (position === 0) {
      new_position = this.formControl.length - 1;
    }

    this.reorder(position, new_position);
  }

  moveDown(position) {
    let new_position = position + 1;

    if (position === this.formControl.length - 1) {
      new_position = 0;
    }

    this.reorder(position, new_position);
  }

  add(i?: number, initialModel?: any): void {
    super.add(i, initialModel);
    this.cdRef.detectChanges();

    if (this.props.hooks && this.props.hooks.itemAdded) {
      const added = this.model[this.model.length - 1];
      this.props.hooks.itemAdded(added);
    }
  }

  remove(i: number): void {
    super.remove(i);
  }

  private reorder(oldPosition: number, newPosition: number) {
    const model = this.model[oldPosition];
    this.remove(oldPosition);
    this.add(newPosition, model);
  }
}
